var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51621 6.57666H0.337097V19.9036H4.51621V6.57666Z",
    fill: "#0027F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.821 6.28792C15.667 6.26866 15.5033 6.25903 15.3396 6.2494C12.9996 6.15311 11.6804 7.53972 11.2182 8.13674C11.0931 8.30044 11.0353 8.39673 11.0353 8.39673V6.61531H7.03912V19.9422H11.0353H11.2182C11.2182 18.5845 11.2182 17.2364 11.2182 15.8787C11.2182 15.1469 11.2182 14.415 11.2182 13.6832C11.2182 12.7781 11.1508 11.8151 11.6034 10.987C11.9886 10.2937 12.6819 9.94704 13.4618 9.94704C15.7729 9.94704 15.821 12.0366 15.821 12.2292C15.821 12.2388 15.821 12.2484 15.821 12.2484V20H20.0001V11.3048C20.0001 8.32932 18.4883 6.57679 15.821 6.28792Z",
    fill: "#0027F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42657 4.85316C3.76674 4.85316 4.85316 3.76674 4.85316 2.42658C4.85316 1.08642 3.76674 0 2.42657 0C1.08641 0 0 1.08642 0 2.42658C0 3.76674 1.08641 4.85316 2.42657 4.85316Z",
    fill: "#0027F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ab1b1e8001f28c3a7ea5f061253d8ac2.svg";
export { ForwardRef as ReactComponent };